// extracted by mini-css-extract-plugin
export default {"root":"Rd702YXShY1OGOT6pppn"};